import { useContext, useEffect, useState } from "react";
//import { withRouter } from 'react-router-dom'
import UserContext from "../../contexts/user";

const AWS = require("aws-sdk");
AWS.config.region = "eu-west-2"; // Région
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: "eu-west-2:13d810d5-435e-453b-8cd4-c3ea362d4d89",
  Logins: {
    "cognito-idp.eu-west-2.amazonaws.com/eu-west-2_Bm4KP9CbL":
      getUrlVars()["id_token"],
  },
});

function getUrlVars() {
  const vars = {};
  window.location.href.replace(
    /[#&]+([^=&]+)=([^&]*)/gi,
    function (m, key, value) {
      vars[key] = value;
    }
  );
  return vars;
}

const Authenticated = ({ children }) => {
  const [, userDispatcher] = useContext(UserContext);
  const [canRender, setCanRender] = useState(false);

  useEffect(() => {
    //fetchUserData()
    // eslint-disable-next-line react-hooks/exhaustive-deps

    AWS.config.credentials.refresh((a) => {
      //console.log("🔴", getUrlVars()['access_token'] || localStorage.getItem('token'))
      const b = new AWS.CognitoIdentityServiceProvider();
      b.getUser(
        {
          AccessToken:
            getUrlVars()["access_token"] || localStorage.getItem("token"),
        },
        function (err, data) {
          if (err) {
            console.log("Error, token not found or not valid !");
            //window.location.replace("https://auth.alloreview.com/login?client_id=193pbgh938lhpgjf5efeldifc5&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=" + window.location.origin);
            window.location.replace(
              "https://auth.alloreview.com/login?client_id=193pbgh938lhpgjf5efeldifc5&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=" +
                window.location.origin +
                "&state=path=" +
                window.location.pathname +
                "&" +
                getUrlVars()["state"]
            );
          } else {
            // extract user info and put them in the context
            const user = {};
            data.UserAttributes.forEach((attr) => {
              user[attr.Name] = attr.Value;
            });
            userDispatcher({
              type: "update-user-info",
              name: data.Username,
              email: user.email,
              phoneNumber: user.phone_number,
            });

            // Put token in local storage
            if (getUrlVars()["access_token"] && getUrlVars()["id_token"]) {
              localStorage.setItem("token", getUrlVars()["access_token"]);
              localStorage.setItem("id_token", getUrlVars()["id_token"]);
              const url_params = getUrlVars();
              delete url_params["access_token"];
              delete url_params["id_token"];
              delete url_params["expires_in"];
              delete url_params["token_type"];

              window.history.pushState(
                {},
                "",
                window.location.href.split("#")[0] +
                  url_params["state"].split("=")[1].slice(1)
              );
              //window.location.replace(window.location.href.split('#')[0] + url_params['state'].split('=')[1].slice(1))
            }
            setCanRender(true);
            //window.tracker.setUserID(data["Username"])
          }
        }
      );
    });
  }, []);

  return canRender && children;
};

Authenticated.propTypes = {};

export default Authenticated;
